import React from "react";
import { useAppContext } from "../hooks/useAppContext";
import { getTranslation } from "../locales/getTranslation";
import sidebarTranslation from "../locales/sidebar.json";

type ModalDeleteProps = {
  deleteChat?: () => void;
  setOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const ModalDelete = ({ deleteChat, setOpenDeleteModal }: ModalDeleteProps) => {
  const { locale } = useAppContext();
  return (
    <div className="flex flex-col items-center justify-center gap-[20px] rounded-[28px] bg-grayscale-solid-elevate-level1 p-8 shadow md:gap-[32px] md:rounded-[32px] md:p-12">
      <div className="flex flex-col items-center justify-center gap-[14px]">
        <h1 className="text-center text-sm font-medium leading-[150%] text-grayscale-solid-g10 md:text-[16px] lg:text-[20px]">
          {getTranslation(locale, "Delete Conversation Confirmation")}
        </h1>
      </div>
      <hr className="h-[1px] w-full border-[1px] border-[#EBEBEE]" />
      <div className="flex items-center justify-center gap-[6px]">
        <button
          className="rounded-xl px-4 py-[6px] text-[12px] font-medium text-grayscale-solid-g10 outline outline-1 outline-offset-[-1px] outline-grayscale-opacity-blevel4 transition-colors hover:bg-red-solid-red6 hover:text-grayscale-solid-fixed-white hover:outline-0 md:px-6 md:py-[8px] md:text-[14px] lg:px-6 lg:py-[8px]"
          onClick={deleteChat}
        >
          {sidebarTranslation["Delete"][locale]}
        </button>
        <button
          className="rounded-xl px-4 py-[6px] text-[12px] font-medium text-grayscale-solid-g10 outline outline-1 outline-offset-[-1px] outline-grayscale-opacity-blevel4 transition-colors hover:bg-blue-solid-blue6 hover:text-grayscale-solid-fixed-white hover:outline-0 md:px-6 md:py-[8px] md:text-[14px] lg:px-6 lg:py-[8px]"
          onClick={() => setOpenDeleteModal(false)}
        >
          {sidebarTranslation["Cancel"][locale]}
        </button>
      </div>
    </div>
  );
};

export default ModalDelete;
